import TravelMap from './../map';
import GuideFilter from './../filter';

import AdditionalPlaces from './additional-places'
import PageGroup from './page-group';

var FavoritesActions = require('../../actions/favorites-actions');

//TODO move this once you deal with the headers
var MobileResultHeader = React.createClass({

  render: function() {
    var mapView = this.props.mobileCurrentView === "map-view" ? "list-view" : "map-view",
        filterView = this.props.mobileCurrentView === "filter-view" ? "list-view" : "filter-view";

    return (
      <div className="result-header col-xs-12">

        <div className="right-col map-view-btn">
          <a className='btn btn-md' href="javascript:void(0)" onClick={this.props.onChangeView.bind(null, mapView)}>
            <i className="fa fa-map-marker"></i>
          </a>
        </div>

        <div className="right-col filter-btn">
          <a className='btn btn-md' href="javascript:void(0)" onClick={this.props.onChangeView.bind(null, filterView)}>
            <i className="fa fa-sliders"></i>
          </a>
        </div>

      </div>
    );
  }
});

var PageGroups = React.createClass({

  narrowColClass: 'narrow-col',
  wideColClass: 'wide-col',
  
  getInitialState: function() {
    return {
      mapExpanded: false
    };
  },

  toggleMap: function() {
    this.setState({
      mapExpanded: !this.state.mapExpanded
    });
  },
  componentDidUpdate: function() {
    if (this.props.isSmallScreen && this.props.mobileCurrentView === 'map-view') {
      this.refs.mapComponent.redrawMap();
    }

    setTimeout(() => FavoritesActions.updateView(), 200);
  },

  onChangeView: function(view) {
    this.props.onChangeView(view);
  },
  
  render: function() {
    if (this.props.plan) {
      var plan = this.props.plan,
          groups = this.props.groups,
          numGroups = groups.length,
          that = this;
      
      //TODO: this can be refactored, but it's fine for now
      var agendaColClass = this.wideColClass,
          mapColClass = this.narrowColClass;

      if (this.state.mapExpanded) {
        agendaColClass = this.narrowColClass;
        mapColClass = this.wideColClass;
      } else {
        agendaColClass = this.wideColClass;
        mapColClass = this.narrowColClass;
      }

      var pageGroups = [],
          itemOffset = 0;

      groups.forEach(function(group, index){
        pageGroups.push(<PageGroup key={index} group={group} index={index} itemOffset={itemOffset} isSmallScreen={that.props.isSmallScreen} useRelativeDate={ that.props.useRelativeDate } autoImageUrls={ that.props.autoImageUrls } />);
        itemOffset += group.items.length;
      });

      if (this.props.isSmallScreen) {
        var mobileResultsHeader =  <MobileResultHeader onChangeView={this.onChangeView} mobileCurrentView={this.props.mobileCurrentView} /> ;
        
        if (this.props.mobileCurrentView === 'map-view') {
          agendaColClass = 'no-width';
          mapColClass = 'full-width';          
        } else {
          agendaColClass = 'full-width';
          mapColClass = 'no-width';
        }

        console.log(this.props.viewType, this.props.mobileCurrentView)

        if (this.props.viewType === "map-view" || this.props.mobileCurrentView === 'map-view') {
          if (this.props.mobileCurrentView === 'map-view'){
            $(document.body).addClass("mobile-map-view");
            setTimeout(function(){
              $(window).trigger("show-map");
            }, 100)
            // return (
            //   <div id="mobile-map-view" className='map-column'>
            //     <TravelMap ref="mapComponent" plan={plan} onChangeView={this.onChangeView} numPlaces={this.props.numPlaces} isSmallScreen={this.props.isSmallScreen}/>
            //   </div>
            // )
          } else {
            return (
              <div id={ this.props.viewType }>
                <div id="mobile-map-view" className='map-column'>
                  <TravelMap ref="mapComponent" plan={plan} onChangeView={this.onChangeView} numPlaces={this.props.numPlaces} isSmallScreen={this.props.isSmallScreen}/>
                </div>
              </div>
            );
          }
        } else {
          $(document.body).removeClass("mobile-map-view");
        }



        return (
          <div>
            {mobileResultsHeader}  
            <div id={this.props.viewType} className="info-section block-holder">
              <div className={'agenda-column full-width'}>
                <div>
                  {pageGroups}
                  <AdditionalPlaces places={plan.additional_places} isSmallScreen={this.props.isSmallScreen} autoImageUrls={ this.props.autoImageUrls } />
                </div>
              </div>
              <div id="mobile-map-view" className='map-column'>
                <TravelMap ref="mapComponent" plan={plan} onChangeView={this.onChangeView} numPlaces={this.props.numPlaces} isSmallScreen={this.props.isSmallScreen}/>
              </div>
            </div>
          </div>
        );
      }

      var mapMarkup = !this.props.mapFor ? "" : <TravelMap ref="mapComponent" plan={plan} guideState={this.props.guideState} guideApi={this.props.guideApi} mapExpanded={this.state.mapExpanded} onToggleMap={this.toggleMap} numPlaces={this.props.numPlaces} isSmallScreen={this.props.isSmallScreen} mapFor={this.props.mapFor} />

      return (
        <div>
          <div id={this.props.viewType} className="info-section block-holder">
            <div className={'map-column ' + mapColClass}>
              { mapMarkup }
            </div>
            <div className={'agenda-column ' + agendaColClass}>
              <div>
                {pageGroups}
                <AdditionalPlaces places={plan.additional_places} isSmallScreen={this.props.isSmallScreen} autoImageUrls={ this.props.autoImageUrls } />
              </div>
            </div>
          </div>
        </div>
      );
    } else if (this.props.loading) {
      return <img className="plan loading" src="/images/ajax-loader.gif" /> ;
    }
    return null;
  }
});

module.exports = PageGroups


// WEBPACK FOOTER //
// ./components/guide-components/page-groups.js